import { Component, OnInit } from '@angular/core';
import { MatSelectChange } from '@angular/material';
import { NotificationService } from '../../shared/notification.service';

@Component({
  selector: 'cc-priority',
  templateUrl: './priority.component.html',
  styleUrls: ['./priority.component.scss']
})
export class PriorityComponent implements OnInit {
  public priorityList = [
    {
      name: 'High'
    },
    {
      name: 'Medium'
    },
    {
      name: 'Low'
    }
  ];

  public selectedPriority = this.priorityList[0];

  constructor(private notify: NotificationService) {}

  ngOnInit() {}

  onSelectPriority(event: MatSelectChange) {
    this.selectedPriority = event.value;
    this.notify.open('PHONE.PRIORITY.SUCCESS');
  }
}
